// ua 库不支持 node 故这里做个同构
import { IF_NODE } from "./if-node";

// 小程序下没有 navigator 会报错

export var isIOS = function isIOS() {
  return IF_NODE || !navigator ? false : /(iphone|ipad|ipod)/i.test(navigator.userAgent);
};
export var isSafari = function isSafari() {
  return IF_NODE || !navigator ? false : /Version\/\S+( Mobile\S*)? Safari\/\S+$/i.test(navigator.userAgent);
};
//# sourceMappingURL=ua.js.map